import { InfoFilledIcon } from '@calizahq/react-components-v2'
import React from 'react'
import { Link } from 'react-router-dom'

import { Tag } from '@/components'
import { LineTagType } from '@/components/LineItem/LineItem'
import { HomeQualityCheckStatus } from '@/types/HomeQualityCheck'
import { ReservationsListRow } from '@/types/Reservation'
import { formatDate, parseDate } from '@/util'

export const ReservationsListColumns = [
  {
    Header: 'Reservation',
    accessor: 'name',
    width: 70,
    Cell: function _Cell({ row }: { row: { original: ReservationsListRow } }) {
      const { home } = row.original

      return (
        <div className="flex items-center justify-center" title="View Home">
          <div className="flex flex-col font-medium">
            <Link to={`/homes/${home.id}`}>
              <h3 className="font-bold hover:underline">{home.searchDocument}</h3>
            </Link>
          </div>
        </div>
      )
    },
  },
  {
    Header: 'Status',
    accessor: 'homeQualityStatus',
    Cell: ({ value }: any) => {
      return (
        <Tag className="ml-2" variant={value === HomeQualityCheckStatus.READY ? 'success' : 'error'}>
          {value}
        </Tag>
      )
    },
    width: 20,
  },
  {
    Header: 'Member',
    accessor: 'member.fullName',
    width: 30,
  },
  {
    Header: 'Phone',
    accessor: 'member.phone',
    width: 30,
  },
  {
    Header: 'Booking Platform',
    accessor: 'source',
    width: 30,
    Cell: function _Cell({ value }: { value?: number }) {
      const platforms: Record<number, string> = {
        0: 'Landing',
        1: 'Airbnb',
        2: 'VRBO',
        3: 'Corporate Housing',
        4: 'Marriott',
        5: 'Booking.com',
        6: 'Google Travel',
        7: 'Corporate Bid',
        8: 'Expedia',
        9: 'Barsala Direct',
        10: 'Rentals United',
      }
      return <span>{value !== undefined ? (platforms[value] ?? 'Unknown') : '—'}</span>
    },
  },
  {
    Header: 'Move In Date',
    accessor: 'moveInDate',
    width: 30,
  },
  {
    Header: 'Move Out Date',
    accessor: 'moveOutDate',
    width: 30,
  },
  {
    accessor: 'id',
    width: 10,
    Cell: function _Cell({ value }: any) {
      return (
        <div className="ml-auto flex items-center justify-center" title="View Reservation">
          <Link to={`/reservations/${value}`}>
            <InfoFilledIcon className="ml-2 text-green-300" height={24} width={24} />
          </Link>
        </div>
      )
    },
  },
]

export function reservationListMapper(reservations: ReservationsListRow[]) {
  return reservations.map((reservation) => ({
    ...reservation,
    name: reservation.home.searchDocument,
    moveOutDate: reservation.moveOutDate ? formatDate(parseDate(reservation.moveOutDate), 'MM/dd/yyyy') : 'Indefinite',
    moveInDate: reservation.moveInDate ? formatDate(parseDate(reservation.moveInDate), 'MM/dd/yyyy') : null,
  }))
}

export function getReservationFXTag(reservation: ReservationsListRow): { label: string; tag: LineTagType } | undefined {
  if (reservation.flightxInProgress) {
    return { label: 'Flight X', tag: 'error' }
  }

  return undefined
}

export function getReservationLexitTag(
  reservation: ReservationsListRow,
): { label: string; tag: LineTagType } | undefined {
  if (reservation.lexit) {
    return { label: 'Lexit', tag: 'error' }
  }

  return undefined
}
